var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEth2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eth",
    clipPath: "url(#clip0_1_3220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.36696 8.87455V0L0 12.2228L7.36696 8.87455Z",
    fill: "#8A92B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.36696 16.579V8.87455L0 12.2228L7.36696 16.579ZM7.36696 8.87455L14.7339 12.2228L7.36696 0V8.87455Z",
    fill: "#62688F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.36694 8.87451V16.579L14.7339 12.2227L7.36694 8.87451Z",
    fill: "#454A75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.36696 17.9743L0 13.6226L7.36696 24.0047V17.9743Z",
    fill: "#8A92B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.7384 13.6226L7.36694 17.9743V24.0047L14.7384 13.6226Z",
    fill: "#62688F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7384,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth2);
export default __webpack_public_path__ + "static/media/eth-2.c07f16c51544994b904bf8adac290ea1.svg";
export { ForwardRef as ReactComponent };